import * as React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n';
import { unregister } from './serviceWorker';
import 'react-loading-skeleton/dist/skeleton.css';

// Suppress React warnings from third-party libraries
const suppressedWarnings = [
  'Support for defaultProps will be removed from function components',
  'componentWillMount has been renamed',
  'componentWillReceiveProps has been renamed',
  'findDOMNode is deprecated',
  "Can't perform a React state update on a component that hasn't mounted yet",
  'You provided a `checked` prop to a form field without an `onChange` handler',
  'memoized state before processing',
  'Selector unknown returned a different result when called with the same parameters',
];

const shouldSuppress = (message: string) => suppressedWarnings.some(warning => message.includes(warning));

const originalConsoleWarn = console.warn;
const originalConsoleError = console.error;

console.warn = (...args) => {
  if (typeof args[0] === 'string' && shouldSuppress(args[0])) {
    return;
  }
  originalConsoleWarn.apply(console, args);
};

console.error = (...args) => {
  if (typeof args[0] === 'string' && shouldSuppress(args[0])) {
    return;
  }
  originalConsoleError.apply(console, args);
};

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(<App />);

unregister();
